import { GetCurrentLoginInformation } from '@/app/shared/services/accountService/accountService';
import router from '@/app/app-routes';

// Load tenantId from localStorage on initialization
const getInitialTenantId = () => {
  try {
    const storedTenantId = localStorage.getItem('tenantId');
    if (storedTenantId) {
      const parsed = parseInt(storedTenantId, 10);
      if (!isNaN(parsed)) {
        return parsed;
      }
    }
  } catch (e) {
    // If localStorage read fails, use default
  }
  return process.env.NODE_ENV === 'production' ? 5 : 3;
};

const userStore = {
  state: {
    userId: 0,
    tenantId: getInitialTenantId(),
    contactDetailsId: '0D18B084-5957-4C61-011D-08D87A904424',
    accessToken: undefined,
    isAuthenticated: false,
    emailAddress: '',
    forename: '',
    surname: '',
    username: '',
    tenant: null,
  },

  getters: {
    getAccessToken(state) {
      return state.user.accessToken;
    },
  },

  mutations: {
    setAccessToken(state, value) {
      state.accessToken = value;
      localStorage.setItem('accessToken', JSON.stringify(value));
      if (value === undefined) {
        state.isAuthenticated = false;
        router.push('/Login');
      } else {
        state.isAuthenticated = true;
      }
    },

    setTenant(state, value) {
      state.tenantId = value;
      // Save tenantId to localStorage
      try {
        localStorage.setItem('tenantId', value.toString());
      } catch (e) {
        // If localStorage write fails, continue without saving
      }
    },

    emptyUserStore(state) {
      state.userId = 0;
      state.accessToken = undefined;
      state.isAuthenticated = false;
      state.emailAddress = '';
      state.forename = '';
      state.surname = '';
      state.username = '';
      state.tenant = null;
    },

    setUserLoginInformation(state, value) {
      if (value.user !== null) {
        state.userId = value.user.id;
        state.emailAddress = value.user.emailAddress;

        state.forename = value.user.name.toLowerCase()
          .charAt(0).toUpperCase() + value.user.name.slice(1);

        state.surname = value.user.surname.toLowerCase()
          .charAt(0).toUpperCase() + value.user.surname.slice(1);

        state.username = value.user.userName;
        state.tenant = value.tenant;
      }
    },
  },

  actions: {
    setAccessToken(context, value) {
      return new Promise((resolve) => {
        context.commit('setAccessToken', value);
        resolve();
      });
    },

    emptyUserStore(context, value) {
      return new Promise((resolve) => {
        context.commit('emptyUserStore', value);
        resolve();
      });
    },

    async getUserLoginInformation({ commit }) {
      await GetCurrentLoginInformation().then(
        (data) => {
          commit('setUserLoginInformation', data);
        },
        () => {

        },
      );
    },

    emptyAccessToken(context) {
      return new Promise((resolve) => {
        context.commit('setAccessToken', undefined);
        resolve();
      });
    },
  },

};

export { userStore };
